export default "__VITE_ASSET__Bg6UJYg2__"